import { VehicleVersion } from './vehicle-version';
import { VehicleEquipment } from './vehicle-equipment';

export class VehicleInfo {
  vehiclePlate: string;
  registrationDate: Date;           // data immatricolazione
  registrationPeriod: string;
  chassisCode: string;
  foreignPlate: boolean;


  versions: VehicleVersion[] = [];
  /**
   * Proprietà valorizzata con tutti gli equipaggiamenti di tutte le versioni (senza doppi)
   * per la visualizzazione nello tabella wizard e nella tabella delle versioni
   */
  allEquipments: VehicleEquipment [] = [];
}



